import { usePaymentMethodsStripeContext } from '../payment-methods-stripe.context';
import { CardOnFileProviderWrapper } from './card-on-file-provider-wrapper';

export type AddCardProviderStripeProps = React.PropsWithChildren<object>;
export const AddCardProviderStripe = ({ children }: AddCardProviderStripeProps) => {
  const { person, invoiceId, onError } = usePaymentMethodsStripeContext();

  return (
    <CardOnFileProviderWrapper personId={person?.personId} invoiceId={invoiceId} onError={onError}>
      {children}
    </CardOnFileProviderWrapper>
  );
};
